export function findCodeAreaControlCodeOccurrences(input) {
  const regex = /-- BEGIN CONTROL CODE/g
  const regexEnd = /-- END CONTROL CODE/g
  const matches: { from: number; to?: number }[] = []
  let match

  while ((match = regex.exec(input)) !== null) {
    const startPosition = match.index
    const lines = input.substring(0, startPosition).split('\n')
    const lineNumber = lines.length
    matches.push({
      from: lineNumber
    })
  }
  let c = 0
  while ((match = regexEnd.exec(input)) !== null) {
    const startPosition = match.index
    const lines = input.substring(0, startPosition).split('\n')
    const lineNumber = lines.length
    matches[c] = {
      ...matches[c],
      to: lineNumber
    }
    c++
  }

  return matches
}
